import _isEmpty from "lodash/isEmpty";
import _isUndefined from "lodash/isUndefined";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { createAction } from 'redux-actions';
import { actionCreators as api } from '../api/actions';
var prefix = 'Account:';
export var REQUEST_USER_INFORMATION = "".concat(prefix, " Request user information.");
export var RECEIVE_USER_INFORMATION = "".concat(prefix, " Receive user information.");
export var REQUEST_UPDATE_ACCOUNT = "".concat(prefix, " Request update account");
export var RECEIVE_UPDATE_ACCOUNT = "".concat(prefix, " Receive update account");
export var RECEIVE_UPDATE_ACCOUNT_ERROR = "".concat(prefix, " Receive update account with error");
var requestUserInformation = createAction(REQUEST_USER_INFORMATION);
var receiveUserInformation = createAction(RECEIVE_USER_INFORMATION);
var requestUpdateAccount = createAction(REQUEST_UPDATE_ACCOUNT);
var receiveUpdateAccount = createAction(RECEIVE_UPDATE_ACCOUNT);
var receiveUpdateAccountError = createAction(RECEIVE_UPDATE_ACCOUNT_ERROR);

var fetchUserInformation = function fetchUserInformation() {
  var forceRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function (dispatch) {
    dispatch(requestUserInformation());
    return dispatch(api.fetch('auth/v1/me', {
      force_refresh: forceRefresh
    })).then(function (response) {
      return dispatch(receiveUserInformation(response.data));
    }, function (error) {
      dispatch(receiveUserInformation(error));
    });
  };
};
/**
 * Updates the blocket settings of the account
 *
 * @param {object} updatedProperties - the properties to update with its new values
 */


var updateAccountSettings = function updateAccountSettings(updatedProperties) {
  return function (dispatch, getState) {
    // Setup model to send to API
    var settingsModel = _objectSpread(_objectSpread({}, {
      region: getState().user.propertyMap.region,
      munic: getState().user.propertyMap.munic,
      subarea: getState().user.propertyMap.subarea,
      accept_newsletter: getState().user.propertyMap.acceptNewsletter,
      mc_send_email_copy: getState().user.propertyMap.mcSendEmailCopy,
      account_id: getState().user.propertyMap.accountId
    }), _isUndefined(updatedProperties) ? {} : updatedProperties); // Set region, munic and region to str "0" when they are empty to avoid trans error


    settingsModel.region = _isEmpty(settingsModel.region) ? '0' : settingsModel.region;
    settingsModel.munic = _isEmpty(settingsModel.munic) ? '0' : settingsModel.munic;
    settingsModel.subarea = _isEmpty(settingsModel.subarea) ? '0' : settingsModel.subarea; // Send post to blocket API

    dispatch(requestUpdateAccount());
    return dispatch(api.fetch('auth/v1/me/property_map', {
      method: 'PUT',
      body: JSON.stringify(settingsModel)
    })).then(function () {
      dispatch(receiveUpdateAccount());
      dispatch(fetchUserInformation(true));
    }, function (error) {
      dispatch(receiveUpdateAccountError(error));
    });
  };
};

export var actionCreators = {
  fetchUserInformation: fetchUserInformation,
  receiveUserInformation: receiveUserInformation,
  updateAccountSettings: updateAccountSettings
};
//# sourceMappingURL=actions.js.map